import { inputStyles } from "../styles/styles";
import { Grid, Button } from "@material-ui/core";
import React from "react";
import BaseWindow from "./public/BaseWindow";
import success from "../images/success.png";
import timeout from "../images/timeout.png";
import { getErrorMessage } from "../utils/enums";
import { getTransferContent } from "../utils/transferContent";
import { connect } from "react-redux";

 function Success(props) {
  const classes = inputStyles();
  return (
    <BaseWindow>
      <Grid item xs={12} style={{ textAlign: "center", marginTop: 50 }}>
        <div style={{ width: "100%" }}>
          <img alt="success" src={props.processContext.usedWithBatch === "2" ? timeout : success} width={100} height={100} />
        </div>
        <div style={{ width: "100%" }}>
            <p>
              {props.processContext.usedWithBatch === "2"
                ? getErrorMessage("MS0029")
                : getTransferContent(
                    props.processContext.doTransferToCompany
                  ).successMessage}
            </p>
          </div>
      </Grid>
      <Grid container item xs={12} style={{ paddingTop: 50, display:'flex', justifyContent:'center' }}>
        {props.processContext.used?.shopUrl && (
          <Button
            variant="contained"
            color="default"
            onClick={()=>{
              window.location.href = props.processContext.used?.shopUrl?.split(';')[0];
            }}
          >
            Güvenli Çıkış
          </Button>
        )}
      </Grid>
    </BaseWindow>
  );
}

const mapStateToProps = (state) => {
  return {
    processContext: state.processContext,
  };
};



export default connect(mapStateToProps)(Success);
